import { baseGrtURL } from '../httpService/API';
import { hMacAjax } from '../httpService';
const reqUrl = `${baseGrtURL}/api/grt-user-center-service`;
export const url = {
    create: `${reqUrl}/user/ai/trans/v1/create`, //创建保存转写文件
    getTransInfoList: `${reqUrl}/user/ai/trans/v1/list`, //获取转录列表
    updateTitle: `${reqUrl}/user/ai/trans/v1/updateTitle`, //修改文件名称
    delete: `${reqUrl}/user/ai/trans/v1/delete`, //（批量）删除资源文件
    getDetailInfo: `${reqUrl}/open/ai/getDetailInfo`, //获取资源转写详情
    getDocumentPlayInfo: `${reqUrl}/user/ai/trans/v1/getDocumentPlayInfo`, //获取资源播放信息
    getTransList: `${reqUrl}/user/ai/trans/v1/getTransList`, //获取转写中、转写失败文件列表
    retryTrans: `${reqUrl}/user/ai/trans/v1/retryTrans`, //重新转写
    translation: `${reqUrl}/user/ai/trans/v1/translation`, //翻译
    getTranslationStatus: `${reqUrl}/user/ai/trans/v1/getTranslationStatus`, //获取翻译状态
    getMindInfoByParams: `${reqUrl}/user/ai/trans/v1/getMindInfoByParams`, //获取转写的markdown
    getCanRecordStatus: `${reqUrl}/user/ai/trans/v1/checkRecording` //获取能否录音状态
};

//创建保存转写文件
export const handleCreate = (data,agent_id,tools_id) => {
    return hMacAjax.post(url.create+"?agent_id="+agent_id+"&tools_id="+tools_id, data);
};

//获取所有智能体列表
export const handleGetTransInfoList = (data) => {
    return hMacAjax.post(url.getTransInfoList, data);
};

//修改文件名称
export const handleUpdateTitle = (id,data) => {
    return hMacAjax.put(url.updateTitle+'/' + id,{...data});
};

//（批量）删除资源文件
export const handleDelete = (data) => {
    return hMacAjax.post(url.delete, {...data});
};

//获取资源转写详情
export const handleGetDetailInfo = (data) => {
    return hMacAjax.get(url.getDetailInfo, data);
};

//获取资源播放信息
export const handleGetDocumentPlayInfo = (data) => {
    return hMacAjax.get(url.getDocumentPlayInfo, data);
};

//获取转写中、转写失败文件列表
export const handleGetTransList = () => {
    return hMacAjax.get(url.getTransList);
};

//重新转写
export const handleRetryTrans = (id) => {
    return hMacAjax.put(url.retryTrans + '?document_id='+ id);
};

//翻译
export const handleTranslation = (data) => {
    return hMacAjax.put(url.translation, data);
};

//获取翻译状态
export const handleGetTranslationStatus = (data) => {
    return hMacAjax.get(url.getTranslationStatus, data);
};

export const fetchMarkdownDataByType = (document_id,style)=>{
    return hMacAjax.get(url.getMindInfoByParams,{document_id,style});
}

export const fetchCheckCanRecord = ()=>{
    return hMacAjax.get(url.getCanRecordStatus,{});
}


